<template>
  <div>
    <page-header has-return :page="page" @onReturn="() => $router.back()" />
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';

import AcademicYearServices from '@/services/api/academicyear.api';
import LocationServices from '@/services/api/location.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        collections: {
          academicYears: [],
          centers: [],
          regions: [],
          municipalities: [],
          schools: [],
        },
        filters: {
          academicYear: null,
          center: null,
          region: null,
          municipality: null,
          school: null,
        },
      },
    },
  }),
  computed: {
    page() {
      return {
        icon: 'fas fa-file-invoice',
        title: 'Maestros por Alternativas',
        routes: ['Informes', 'Maestros por Alternativas'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-2',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CSEE',
          placeholder: 'Seleccionar',
          class: 'col-md-2',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          disabled: this.model.search.collections.centers.length == 1,
          onChanged: this.getRegion,
        },
        {
          name: 'region',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Región',
          placeholder: 'Seleccionar',
          clearable: false,
          class: 'col-md-2',
          options: this.model.search.collections.regions,
          value: this.model.search.filters.region,
          disabled: this.model.search.collections.regions.length == 1,
          onChanged: this.getMunicipalities,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          options: this.model.search.collections.municipalities,
          label: 'Municipio',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          onChanged: this.getSchools,
          value: this.model.search.filters.municipality,
          class: 'col-md-2',
          disabled: this.model.search.collections.municipalities.length == 1,
        },
        {
          name: 'school',
          component: 'custom-drop-down',
          options: this.model.search.collections.schools,
          value: this.model.search.filters.school,
          label: 'Escuela',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          onChanged: this.onChangedSchool,
          class: 'col-md-2',
          disabled: this.model.search.collections.schools.length == 1,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getInitialFilters() {
      this.model.search.collections.academicYears = (
        await AcademicYearServices.getCurrentYearAcademicYears()
      ).data;
    },
    async onChangeAcademicYear() {
      await this.getCenters();
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear.id,
      }).then((res) => {
        this.model.search.collections.centers = res.data;
        if(this.model.search.collections.centers.length === 1) {
          this.model.search.filters.center = this.model.search.collections.centers[0];
          this.getRegion();
        }
      });
    },
    async getRegion() {
      await LocationServices.getRegions({
        academicYearId: this.model.search.filters.academicYear?.id,
        centerId: this.model.search.filters.center?.id,
      }).then(({ data }) => {
        this.model.search.collections.regions = data
        if(this.model.search.collections.regions.length === 1) {
          this.model.search.filters.region = this.model.search.collections.regions[0];
          this.getMunicipalities();
        }
      });
    },
    async getMunicipalities() {
      await LocationServices.getMunicipalities({
        academicYearId: this.model.search.filters.academicYear?.id,
        centerId: this.model.search.filters.center?.id,
        regionId: this.model.search.filters.region?.id,
      }).then((res) => {
        this.model.search.collections.municipalities = res.data;
        if(this.model.search.collections.municipalities.length === 1) {
          this.model.search.filters.municipality = this.model.search.collections.municipalities[0];
          this.getSchools();
        }
      });
    },
    async getSchools() {
      await LocationServices.getSchools({
        academicYearId: this.model.search.filters.academicYear?.id,
        centerId: this.model.search.filters.center?.id,
        regionId: this.model.search.filters.region?.id,
        municipalityId: this.model.search.filters.municipality?.id,
      }).then((res) => {
        this.model.search.collections.schools = res.data;
        if(this.model.search.collections.schools.length === 1) {
          this.model.search.filters.school = this.model.search.collections.schools[0];
        }
      });
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (!isValid) return;
      const payload = {
        academicYearId: this.model.search.filters.academicYear?.id,
        centerId: this.model.search.filters.center?.id,
        regionId: this.model.search.filters.region?.id,
        municipalityId: this.model.search.filters.municipality?.id,
        schoolId: this.model.search.filters.school?.id,
      };
      await ReportServices.getTeachersAlternativesReport(payload).then((res) =>
        DocumentServices.Download(res.data)
      );
    },
  },
};
</script>
